import logo from'../content/img/full-logo-lg.png';

const PageLogoHeader = () => {
    return(
        <>
            <div id="title_bar">
                <label id="title">CCBH: DataMine</label>
                <label id="user_name"></label>
            </div>

            <div id="logo-wrapper-login">
                <div className="logo-div" id="logo-div">            
                    <img id="page-logo" src={logo} alt="logo" />
                </div>
            </div>
        </>
    );
}

export default PageLogoHeader;